import { EXCEL_GRID_HEADER_CLASS_NAME } from "../constants/excel-like-grid.constants";
import type { ExcelGridHeaderProps } from "../models/excel-grid-component-props.models";
import { ExcelGridHeaderRow } from "./ExcelGridHeaderRow";

export const ExcelGridHeader = ({
  columns,
  dataTest,
  filters,
  sortState,
  hasFilters,
  onClearFilters,
  onFilterChange,
  onSortToggle,
}: ExcelGridHeaderProps) => (
  <thead className={EXCEL_GRID_HEADER_CLASS_NAME}>
    <ExcelGridHeaderRow
      columns={columns}
      dataTest={dataTest}
      filters={filters}
      sortState={sortState}
      onClearFilters={onClearFilters}
      onFilterChange={onFilterChange}
      onSortToggle={onSortToggle}
      hasFilters={hasFilters}
    />
  </thead>
);
